import { ChipOwnProps } from '@mui/material';
import React, { FC } from 'react';
import { useThemeContext } from '../../../global-state/themeContext';
import { StyledChip } from './Chip.styles';

export type ChipProps = {
  label: React.ReactNode;
  color: ChipOwnProps['color'];
  variant?: 'filled' | 'outlined';
  onClick?: () => void;
  onDelete?: () => void;
  customDeleteIcon?: React.ReactElement;
  disabled?: boolean;
  isSelected?: boolean;
  size?: 'small' | 'medium';
  borderRadius?: string;
};

export const Chip: FC<ChipProps> = ({
  label,
  color,
  variant = 'outlined',
  onClick,
  onDelete,
  customDeleteIcon,
  disabled = false,
  isSelected = false,
  size = 'medium',
  borderRadius = '',
}) => {
  const { mode } = useThemeContext();
  const isDarkMode = mode === 'dark';
  return (
    <StyledChip
      data-testid="chip"
      aria-selected={isSelected}
      label={label}
      color={color}
      variant={variant}
      onClick={onClick}
      onDelete={onDelete}
      $isDarkMode={isDarkMode}
      deleteIcon={customDeleteIcon}
      disabled={disabled}
      size={size}
      sx={{
        borderRadius: borderRadius ? borderRadius : undefined,
      }}
    />
  );
};
